import { Modal, Flex, Box } from "@familyzone/component-library";
import React, { ReactNode } from "react";

interface SleekModalProps {
  show: boolean;
  handleHide: () => void;
  buttons?: ReactNode;
  centerButtons?: boolean;
  noBasePadding?: boolean;
  className?: string;
  title?: string;
  subTitle?: React.ReactNode;
  description?: string;
  children?: ReactNode;
}

const SleekModal: React.FC<SleekModalProps> = ({
  show,
  handleHide,
  buttons,
  centerButtons,
  className,
  title,
  subTitle,
  description,
  children,
}) => {
  return (
    // contentProps={{ overflowY: "auto !important" } is required because there is a scss file in this repo which forces overflow: hidden on the library component
    <Modal isOpen={show} onClose={handleHide} size={"md"} contentProps={{ className, overflow: "auto !important" }}>
      <>
        {title && <h3 className="sleek-modal-title">{title}</h3>}
        {subTitle && (
          <Box textAlign={"center"} marginBottom={"5px"}>
            {subTitle}
          </Box>
        )}
        {description && (
          <Box textAlign={"center"} marginBottom={"24px"}>
            {description}
          </Box>
        )}
        {children}
        {buttons && (
          <Flex mt={"40px"} justify={centerButtons ? "center" : "right"}>
            {buttons}
          </Flex>
        )}
      </>
    </Modal>
  );
};

export default SleekModal;
